import DOMPurify from 'dompurify/dist/purify.es';
window.DOMPurify = DOMPurify;
